import { create } from "zustand";

interface UIState {
  chatWidgetConfirmDialogState: {
    content: string | React.ReactElement;
    title: string;
    confirmButtonText?: string | false;
    cancelButtonText?: string | false;
    maxWidth?: "xs" | "sm" | "md" | "xl";
    fullWidth?: boolean;
    resolve?: ((accept: boolean) => void) | null;
  };
}

interface UIActions {
  chatWidgetConfirmDialog: (
    params: Omit<UIState["chatWidgetConfirmDialogState"], "resolve">
  ) => Promise<boolean>;
}

const initState: UIState = {
  chatWidgetConfirmDialogState: {
    content: "",
    title: "",
    confirmButtonText: "",
    cancelButtonText: "",
    resolve: null,
  },
};

export const useUIStore = create<UIState & UIActions>((set) => ({
  ...initState,
  chatWidgetConfirmDialog: async (params) => {
    const res = await new Promise<boolean>((resolve) => {
      set((state) => ({
        ...state,
        chatWidgetConfirmDialogState: {
          ...state.chatWidgetConfirmDialogState,
          title: params.title,
          content: params.content,
          confirmButtonText: params.confirmButtonText,
          cancelButtonText: params.cancelButtonText,
          maxWidth: params.maxWidth,
          fullWidth: params.fullWidth,
          resolve,
        },
      }));
    });
    set((state) => ({
      ...state,
      chatWidgetConfirmDialogState: {
        ...state.chatWidgetConfirmDialogState,
        resolve: null,
      },
    }));
    return res;
  },
}));
